import React from 'react';
import CommonRequestPage from './components/CommonRequestPage';

const PendingRequest = () => {
  return (
    <CommonRequestPage
      pageType={'pending'}
      pageTitle={'Pending Price Change Request'}
      key={'pending'}
    />
  );
};

export default PendingRequest;
